import { api } from './api';
import type { TopicDetail } from './intelligence';

export interface BoardCard {
  id: number;
  tema: string;
  fonte: string | null;
  origem: string | null;
  metodo: string | null;
  estado: string;
  raia: 'produzir' | 'produzindo' | 'publicado' | string;
  responsavel: string | null;
  erro: string | null;
  editoria: string | null;
  site: string | null;
  wp_post_id: number | null;
  wp_link: string | null;
  score: number | null;
  search_volume: number | null;
  increase_percentage: number | null;
  verdict: string | null;
  num_sources: number | null;
  tem_intel: boolean;
  duplicado?: boolean; // G3: handoff devolveu um card que já estava no quadro
  created_at: string | null;
  updated_at: string | null;
}

export interface BoardData {
  columns: {
    produzir: BoardCard[];
    produzindo: BoardCard[];
    publicado: BoardCard[];
  };
  total: number;
}

export interface BoardFilters {
  responsavel?: string;
  fonte?: string;
  metodo?: string;
  site?: string;
  dias?: number;
}

export interface ProduzirBody {
  metodo: 'ia' | 'framing' | 'nrcs';
  framming?: string;
  site?: string;
  autopublish?: boolean;
}

export const boardApi = {
  get: (f: BoardFilters = {}): Promise<BoardData> => {
    const qs = new URLSearchParams();
    if (f.responsavel) qs.set('responsavel', f.responsavel);
    if (f.fonte) qs.set('fonte', f.fonte);
    if (f.metodo) qs.set('metodo', f.metodo);
    if (f.site) qs.set('site', f.site);
    if (f.dias) qs.set('dias', String(f.dias));
    const s = qs.toString();
    return api.get<BoardData>(`/board${s ? `?${s}` : ''}`);
  },
  enqueue: (body: {
    tema: string;
    fonte?: string;
    site?: string;
    intel?: TopicDetail;
  }): Promise<BoardCard> => api.post<BoardCard>('/board/from-intelligence', body),
  intel: (id: number): Promise<TopicDetail> => api.get<TopicDetail>(`/board/${id}/intel`),
  produzir: (id: number, body: ProduzirBody): Promise<BoardCard> =>
    api.post<BoardCard>(`/board/${id}/produzir`, body),
  retry: (id: number): Promise<BoardCard> => api.post<BoardCard>(`/board/${id}/retry`, {}),
  publicar: (id: number): Promise<BoardCard> => api.post<BoardCard>(`/board/${id}/publicar`, {}),
  remove: (id: number): Promise<{ deleted: boolean }> =>
    api.delete<{ deleted: boolean }>(`/board/${id}`),
};
